import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import ru from "./vee-ru.json";

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// Install rules
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});


localize('ru', ru);

Object.defineProperty(Vue.prototype, "veeLocale", {
  get() {
    return ru;
  },
  set(val) {
    localize(val);
  }
});